import { Theme } from "@bluframe/blublocks"
import Typography from "components/Typography"
import styled from "styled-components"

export const FieldRow = styled.div<{ $items?: number }>`
  align-items: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: ${({ $items = 1 }) => `repeat(${$items}, 1fr)`};
  row-gap: 20px;
`

export const FieldLabelAndValue = styled.div`
  display: grid;
  row-gap: 6px;
`

export const FieldLabel = styled(Typography.Paragraph).attrs({ as: "label" })`
  color: ${({ theme }: { theme: Theme }) => theme.palette.text.main};
  font-weight: 600;
  margin: 0;
`

export const FieldValue = styled(Typography.Paragraph)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.subtitle.main};
  margin: 0;
  max-width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
